<template>
    <div>
        <h3>小程序</h3>

                <el-card class="box-card">
                    <h3>已经拥有微信小程序</h3>
                    <p>授权已有的微信小程序，完成方式设置，发布快速获得会员小程序</p>
                    <el-button type="primary" size="small" @click="auth">授权小程序</el-button>
                </el-card>
                
                <el-card class="box-card">
                    <h3>还没有微信小程序</h3>
                    <p>注册小程序，快速获得会员小程序<br><br></p>
                    <el-button type="primary" size="small">创建试用小程序</el-button>
                </el-card>
    </div>
</template>
<style>
.box-card{ text-align: center; width: 400px; height: 240px; float: left; margin-right: 20px; }
.box-card p{ padding: 10px 0; text-align: left; line-height: 150%;}
</style>
<script>
export default {
    data() {
        return {
        };
    },
    created(){

    },
    methods: {
        auth() {
            this.Data.ComponentApp.GetAuthLink().then(res => {
                console.log(res);
                window.open(res.data);
            });
        },
    },
};
</script>